import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className='min-h-[calc(100vh-48px)] flex items-center justify-center px-4 py-16'>
      <div className='w-full max-w-[560px] rounded-2xl border border-apple-border bg-white px-8 py-10 shadow-card-sm text-center'>
        <p className='text-apple-blue text-[0.75rem] font-semibold uppercase tracking-[0.16em] mb-3'>404</p>
        <h1
          className='font-semibold text-apple-near-black mb-3'
          style={{ fontSize: '2rem', lineHeight: 1.1, letterSpacing: '-0.02em' }}
        >
          页面不存在
        </h1>
        <p className='text-apple-gray max-w-[420px] mx-auto' style={{ fontSize: '0.9375rem', lineHeight: 1.6 }}>
          你访问的页面可能已被移动或删除，请通过下方操作继续使用 CodePilot。
        </p>

        <div className='mt-8 flex flex-col sm:flex-row gap-3 justify-center'>
          <Link to='/' className='btn btn-primary'>
            返回首页
          </Link>
          <Link to='/login' className='btn btn-secondary'>
            去登录页
          </Link>
        </div>
      </div>
    </div>
  );
}